<!--
<div class="header-card d-flex bottom-xs">
  <h2 class="color-blue-light header-card_title u-medium">Aportes</h2>
</div>
  <div class="content-card">

      <div class="row-card">
            <div class="column-one">
               <i class="material-icons"> work </i>
            </div>
            <div class="column-two">
                <span class="tittle-row"> Aportes </span>
            </div>
            <div class="column-three">
                <span class="date-row">12/08/2019</span>
                <span class="text-row">Fecha último aporte</span>
            </div>
            <div class="column-four">
                <span class="date-row">08/2019</span>
                <span class="text-row">Periodo último aporte</span>
            </div>
            <div class="column-five">
                <span class="date-row">$200,000,000</span>
                <span class="text-row">Valor último aporte</span>
            </div>
      </div>

      <hr class="separator-card">

            <div class="row-card">

              <div class="column-one">
                <img src="../../../../../assets/icons/icon-state.svg"alt="">
              </div>
              <div class="column-two">
                <span class="tittle-row"> Estado<br>de los periodos </span>
              </div>

              <div class="column-five">
                <span class="date-row color-red"> <strong> En mora </strong> </span>
                <span class="text-row">Estado</span>
              </div>

            </div>

      <hr class="separator-card">

              <div class="row-card">
                <div class="column-one">
                  <img src="../../../../../assets/icons/icon-devolution.svg" alt="">
                </div>
                <div class="column-two">
                  <span class="tittle-row"> Devoluciones </span>
                </div>
                <div class="column-four">
                  <span class="date-row">03/06/2019</span>
                  <span class="text-row">Fecha de solicitud</span>
                </div>
                <div class="column-five">
                  <span class="date-row">$10,000,000</span>
                  <span class="text-row">Valor último aporte</span>
                </div>
              </div>

      <hr class="separator-card">

        <div class="row-card">
          <div class="column-one">
            <img src="../../../../../assets/icons/icon-transf.svg" alt="">
          </div>
          <div class="column-two">
            <span class="tittle-row"> Transferencias </span>
          </div>
          <div class="column-four">
            <span class="date-row">13/05/2019</span>
            <span class="text-row">Fecha de solicitud</span>
          </div>
          <div class="column-five">
            <span class="date-row">$300,000,000</span>
            <span class="text-row">Valor último aporte</span>
          </div>
        </div>

  </div>


  <div class="content-btn-detail">
    <button class="bnt-datail padding-small"> <i class="material-icons"> navigate_next </i> <span class="text-btn-datail"> Ver detalle </span> </button>
  </div>


  <div class="content-card">
      <h1 class="tittle-card-two"> Devoluciones y transferencias </h1>
      <p class="text-card-two">
        Si realizaste un pago por mayor valor o necesitas transladarlo a otra caja de compensación por favor ingresa aquí y conoce los pasos a seguir para la devolución.
      </p>
  </div>

  <div class="content-btn-detail">
    <button class="bnt-datail padding-small"> <i class="material-icons"> navigate_next </i> <span class="text-btn-datail"> Ver más
      </span> </button>
  </div>
-->

  <div class="content-info-card-three">
      <span class="tittle-row"> Afiliaciones </span>
      <div class="content-info-right">
          <span class="info-afiliate">{{totalAffiliates}}</span>
          <span class="text-row">Total afiliados</span>
      </div>
  </div>
  <div class="content-card-affiliates">

    <div class="column-affiliates tac">

        <app-donut-chart *ngIf="showDonut" [dataLabel]="dChartAffiliationsDataLabels" [data]="dChartAffiliationsData"  style="height: 82px;width: 155px;"></app-donut-chart>
        <!--<img src="../../../../../assets/images/image-graphi-affiliates.png" alt="">-->
        <span class="info-afiliate "> {{totalAffiliatesC}}</span>
          <span class="text-row">Afiliados</span>
    </div>

    <div class="column-affiliates pl">
      <div class="col-sm-12">
        <span class="tittle-row">Trabajadores Activos</span>
        <div class="row-category">

          <div class="content-info-left">
                <span class="text-blue-category margin-0-left"> Trabajadores</span>
                <div class="text-blue-category"> {{affiliatesM}} </div>
          </div>

        </div>

        <div class="row-category">

          <div class="content-info-left">
            <span class="text-blue-category margin-0-left"> Trabajadoras</span>
            <span class="text-blue-category"> {{affiliatesF}} </span>
          </div>
        </div>
      </div>
      <div class="col-sm-12 margin-top-20">
      <span class="tittle-row"> Subsidio Familiar</span>

      <div class="row-category">

        <div class="content-info-left">
              <div class="square-color bg-blue-light"></div>
              <span class="text-blue-category"> Trabajadores con Subsidio familiar</span>
              <span class="text-blue-category"> {{affiliatesCatA}}% </span>
        </div>

      </div>

      <div class="row-category">

        <div class="content-info-left">
          <div class="square-color bg-blue-dark "></div>
          <span class="text-blue-category"> Trabajadores sin Subsidio Familiar</span>
          <span class="text-blue-category"> {{affiliatesCatB}}% </span>
        </div>

      </div>
    </div>
    </div>

  </div>
  <div class="content-card-btns">
      <hr class="separator-card-three">
      <div class="content-btns">
          <button type="button" appDebounceClickGeneral
          data-category="Inicio"
          data-action = "Afiliaciones"
          data-label = "Consultar"
          data-event = "ga_event_afiliaciones"
          class="btn-consult" (click)="openLink(linkConMas)"> Consultar  </button>
      </div>
  </div>

<!--
<div class="header-card d-flex bottom-xs">
  <h2 class="color-blue-light header-card_title u-medium">Afiliaciones masivas en proceso</h2> <div class="tooltip right"> <img src="../../../../../assets/icons/icon-interrogative.svg" alt=""> <span class="tiptext"> Consulta aquí el estado de las afiliaciones de Trabajadores que hayas realizado</span> </div>
</div>

  <div class="content-card">

      <div class="row-card-masive">

          <span class="text-gray-category color-gray">
              Código de proceso
          </span>

          <span class="text-gray-category color-gray">
              Fecha de proceso
          </span>

          <span class="text-gray-category color-gray">
              Estado
          </span>

          <span class="text-gray-category color-gray">

          </span>
      </div>

      <hr class="separator-card">

        <div class="row-card-masive">

          <span class="text-gray-category color-gray">
            GHGGHGK4KK
          </span>

          <span class="text-gray-category color-gray">
            22/02/2019
          </span>

          <span class="text-gray-category color-blue">
            En proceso
          </span>

          <span class="tal text-gray-category color-gray">
            <img src="../../../../../assets/icons/document-blue.svg" alt="">
          </span>

        </div>

        <div class="row-card-masive mt-masive">

          <span class="text-gray-category color-gray">
            GHGGHGK4KK
          </span>

          <span class="text-gray-category color-gray">
            22/02/2019
          </span>

          <span class="text-gray-category color-red">
            Error
          </span>

          <span class="tal text-gray-category color-gray">
            <img src="../../../../../assets/icons/document-blue.svg" alt="">
            <img src="../../../../../assets/icons/document-red.svg" alt="">
          </span>

        </div>

            <div class="row-card-masive mt-masive">

              <span class="text-gray-category color-gray">
                GHGGHGK4KK
              </span>

              <span class="text-gray-category color-gray">
                22/02/2019
              </span>

              <span class="text-gray-category color-green">
                Cargado
              </span>

              <span class="tal text-gray-category color-gray">
                <img src="../../../../../assets/icons/document-blue.svg" alt="">
                <img src="../../../../../assets/icons/document-blue.svg" alt="">
              </span>

            </div>
  </div>
  <div class="content-btn-detail">
    <button class="bnt-datail s-big"> <i class="material-icons"> navigate_next </i> <span class="text-btn-datail"> Ver procesos masivos
      </span> </button>
  </div>

<div class="content-info-card-three">

    <span class="tittle-row"> Subsidios</span>

  <div class="content-info-right">
    <span class="info-afiliate"> 00,000</span>
    <span class="text-row">Total afiliados beneficiados</span>
  </div>
</div>


<div class="content-card ">

  <div class="row-card-masive">

    <span class="text-gray-category color-gray size-mid">
      Tipo de Subsidio
    </span>

    <span class="text-gray-category color-gray size-mid">
      Cantidad beneficiados
    </span>

    <span class="text-gray-category color-gray size-mid">
      Valor
    </span>

    <span class="text-gray-category color-gray size-mid">
      Periodo
    </span>
  </div>

  <hr class="separator-card">

  <div class="row-card-masive">

    <span class="text-blue-subsidy">
      Subsidio familiar
    </span>

    <span class="text-gray-subsidy">
      1,250
    </span>

    <span class="text-gray-subsidy">
      $000,000,000
    </span>

    <span class="tal ttext-gray-category color-gray">
        <div class="d-block">
            <span class="text-blue-subsidy">08/2019</span>
            <span class="text-gray-subsidy-min">Último mes</span>
        </div>
    </span>

  </div>
  <div class="row-card-masive mt-masive">

    <span class="text-blue-subsidy">
      Subsidio de vivienda
    </span>

    <span class="text-gray-subsidy">
      1,250
    </span>

    <span class="text-gray-subsidy">
      $000,000,000
    </span>

    <span class="tal ttext-gray-category color-gray">
      <div class="d-block">
        <span class="text-blue-subsidy">08/2019</span>
        <span class="text-gray-subsidy-min">Último mes</span>
      </div>
    </span>

  </div>
    <div class="row-card-masive mt-masive">

      <span class="text-blue-subsidy">
        Bono lonchera
      </span>

      <span class="text-gray-subsidy">
        1,250
      </span>

      <span class="text-gray-subsidy">
        $000,000,000
      </span>

      <span class="tal ttext-gray-category color-gray">
        <div class="d-block">
          <span class="text-blue-subsidy">08/2019</span>
          <span class="text-gray-subsidy-min">Último mes</span>
        </div>
      </span>

    </div>


</div>
<div class="content-btn-detail">
  <button class="bnt-datail s-big"> <i class="material-icons"> navigate_next </i> <span class="text-btn-datail"> Consultar subsidio

    </span> </button>
</div>

<div class="header-card d-flex ">
  <h2 class="tittle-row">Estado de consultas masivas</h2>
  <div class="tooltip right"> <img src="../../../../../assets/icons/icon-interrogative.svg" alt=""> <span
      class="tiptext"> Consulta aquí el estado de los proceso de Consulta Masiva de Trabajadores que hayas realizado  </span> </div>
</div>

<div class="content-card mt-masive">

          <div class="row-card-state">
            <div class="column-one">
                  <span class="text-gray-category color-gray">
                    Código de proceso
                  </span>
            </div>
            <div class="column-two">
                  <span class="text-gray-category color-gray">
                  Fecha de proceso
                  </span>
            </div>
            <div class="column-three">
                    <span class="text-gray-category color-gray">
                      Estado
                    </span>
            </div>
            <div class="column-four">
                    <span class="text-gray-category color-gray">

                    </span>
            </div>
            <div class="column-five">
              <span class="text-gray-category color-gray">
                Ver detalles
              </span>
            </div>

          </div>

      <hr class="separator-card">

            <div class="row-card-state">
              <div class="column-one">
                    <span class="text-gray-category color-gray">
                      GHGGHGK4KK
                    </span>
              </div>
              <div class="column-two">
                <span class="text-gray-category color-gray">
                  22/02/2019
                </span>
              </div>
              <div class="column-three">
                  <span class="text-gray-category">

                  </span>
              </div>
              <div class="column-four">
                <span class="tal text-gray-category color-gray">
                    <img src="../../../../../assets/icons/document-blue.svg" alt="">
                </span>
              </div>
              <div class="column-five">
                <span class="text-gray-category color-gray">
                <button> <i class="material-icons color-blue-dark"> visibility </i> </button>
                </span>
              </div>

            </div>

            <div class="row-card-state mt-masive">
              <div class="column-one">
                <span class="text-gray-category color-gray">
                  GHGGHGK4KK
                </span>
              </div>
              <div class="column-two">
                <span class="text-gray-category color-gray">
                  22/02/2019
                </span>
              </div>
              <div class="column-three">
                <span class="text-gray-category color-red">
                    Error de validacion
                </span>
              </div>
              <div class="column-four">
                <span class="tal text-gray-category color-gray">
                  <img src="../../../../../assets/icons/document-blue.svg" alt="">
                  <img src="../../../../../assets/icons/document-red.svg" alt="">
                </span>
              </div>
              <div class="column-five">
                <span class="text-gray-category color-gray">
                  <button> <i class="material-icons color-blue-dark"> visibility </i> </button>
                </span>
              </div>

            </div>

            <div class="row-card-state mt-masive">
              <div class="column-one">
                <span class="text-gray-category color-gray">
                  GHGGHGK4KK
                </span>
              </div>
              <div class="column-two">
                <span class="text-gray-category color-gray">
                  22/02/2019
                </span>
              </div>
              <div class="column-three">
                <span class="text-gray-category">

                </span>
              </div>
              <div class="column-four">
                <span class="tal text-gray-category color-gray">
                  <img src="../../../../../assets/icons/document-blue.svg" alt="">
                </span>
              </div>
              <div class="column-five">
                <span class="text-gray-category color-gray">
                  <button> <i class="material-icons color-blue-dark"> visibility </i> </button>
                </span>
              </div>

            </div>
</div>
<div class="content-btn-detail">
  <button class="bnt-datail s-big"> <i class="material-icons"> navigate_next </i> <span class="text-btn-datail"> Ver
      consultas masivos
    </span> </button>
</div>
-->





